module.exports = __webpack_public_path__ + "static/hero3_mob-8c2a395b1dfcb3337457e7146409273d.jpg";